<template>
    <div class="payment-summary payment-summary__card-gap">
        <div
            data-testid="waiveOfCoolingRighsCheckboxError"
            role="alert"
            aria-live="polite"
            class="text-input-error"
            v-if="errorMessage">
            {{ errorMessage }}
        </div>
        <p
            v-if="isSwitchPlan"
            v-html="getLegalCopyForSwitchPlan"
            class="order-summary__update-plan" />
        <CheckboxElm
            v-if="showCheckbox"
            id="ftcWaiveOfCoolingRightsCheckbox"
            data-testid="ftcWaiveOfCoolingRightsCheckbox"
            data-ci="payment-layout__summary__waive-cooling-rights"
            :checkboxConfig="checkboxConfig"
            :errorMessage="errorMessage"
            @change="onCheckboxChange">
            <span v-html="checkboxConfig.inputLabel"></span>
        </CheckboxElm>
        <p
            v-if="!showCheckbox"
            class="payment-summary__disclaimer payment-summary__disclaimer--cooling-rights"
            data-ci="payment-summary__disclaimer"
            v-html="checkboxConfig.inputLabel"></p>
        <p v-html="disclaimer" class="order-summary__cooling-rights-disclaimer" />
        <FormButton
            :buttonConfig="buttonConfig"
            :buttonState="buttonState"
            @click="onSubmit"></FormButton>
    </div>
</template>

<script>
    import CheckboxElm from 'atoms/CheckboxElm';
    import FormButton from 'atoms/FormButton';

    export default {
        name: 'WaiveCoolingRights',
        components: {
            CheckboxElm,
            FormButton,
        },
        props: {
            checkboxConfig: {
                type: Object,
                required: true,
            },
            errorMessage: {
                type: String,
                default: '',
            },
            disclaimer: {
                type: String,
                default: '',
            },
            buttonConfig: {
                type: Object,
                required: true,
            },
            buttonState: {
                type: String,
                required: true,
            },
            showCheckbox: {
                type: Boolean,
                default: true,
            },
            getLegalCopyForSwitchPlan: {
                type: String,
                default: '',
            },
            isSwitchPlan: {
                type: Boolean,
                default: false,
            },
        },
        methods: {
            onCheckboxChange(event) {
                this.$emit('change', event);
            },
            onSubmit(event) {
                this.$emit('submit', event);
            },
        },
    };
</script>
